import React from 'react';
import { useAuth } from '../context/AuthContext';

export default function AccessRestricted() {
  const { logout } = useAuth();

  return (
    <div
      data-testid="access-restricted-page"
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0a0a0a',
      }}
    >
      <div style={{ textAlign: 'center', maxWidth: 400 }}>
        <div style={{ fontSize: 48, marginBottom: 16, color: '#333' }}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#e0e0e0', marginBottom: 8 }}>
          Access Restricted
        </h1>
        <p style={{ fontSize: 14, color: '#666', marginBottom: 24 }}>
          This application is private.
        </p>
        <button
          data-testid="restricted-logout-button"
          onClick={logout}
          style={{
            padding: '8px 24px',
            background: 'transparent',
            border: '1px solid #333',
            borderRadius: 6,
            color: '#888',
            fontSize: 13,
            cursor: 'pointer',
          }}
        >
          Logout
        </button>
      </div>
    </div>
  );
}
